import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const icons: AdminBlockTypeAttribute = {
  label: 'Show icons',
  key: 'icons',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default icons;
